import ResumeButton from './component.styles'
export default ResumeButton
